// extracted by mini-css-extract-plugin
export default {"wrap":"uPg8l","wrap--size-m":"TDYRV","wrap--size-s":"UXyyt"};